//import "@fortawesome/fontawesome-free/css/all.css";
//import "@mdi/font/css/materialdesignicons.css";
import Vue from 'vue'
import Vuetify, { VTextField } from 'vuetify/lib'

Vue.use(Vuetify)
Vue.component('v-text-field', VTextField)
const vuetify = new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#1F396E',
        secondary: '#E73336',
        anchor: '#8c9eff'
      }
    }
  },
  components: {
    VTextField
  },
  icons: {
    iconfont: 'mdiSvg'
  }
})
export default vuetify
